import "core-js/modules/es.array.filter";

var state = function state() {
  return {
    GoodsList: '',
    DealerList: '',
    SchoolList: '',
    OrderList: '',
    MemberList: '',
    RefundList: ''
  };
};

var mutations = {
  STORE_PAGE: function STORE_PAGE(state, msg) {
    var page = msg.page,
        options = msg.options,
        filter = msg.filter;
    state[page] = JSON.stringify({
      options: options,
      filter: filter
    });
  },
  CLEAR_PAGE: function CLEAR_PAGE(state, routeName) {
    state[routeName] = '';
  }
};
var actions = {
  storePage: function storePage(context, msg) {
    context.commit('STORE_PAGE', msg);
  },
  clearPage: function clearPage(context, routeName) {
    context.commit('CLEAR_PAGE', routeName);
  }
};
export default {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations
};